export default __webpack_public_path__ + "static/media/project-view.f59fa078.PNG";